<script setup lang="ts">
    import BSDropdownButton from '@shared/components/BSDropdownButton.vue';

    defineProps<{
        disabled: boolean;
    }>();

    const emit = defineEmits<{
        exportExcel: [];
        exportCsv: [];
        exportToNewList: [];
        exportToExistingList: [];
        sendExcelByMail: [];
    }>();
</script>

<template>
    <BSDropdownButton menuClass="dropdown-menu-right" :disabled="disabled" closeOnClickInside>
        <template #toggle>
            <span class="glyphicon glyphicon-export m-xxs-r"></span>
            {{ $Resources.ExportButton }}
        </template>
        <template #content>
            <li role="presentation" class="dropdown-header">{{ $Resources.ExportToLabel }}:</li>
            <li>
                <a href="javascript:void(0)" role="button" @click="emit('exportExcel')">
                    {{ $Resources.ExportToExcelButton }}
                </a>
            </li>
            <li>
                <a href="javascript:void(0)" @click="emit('exportCsv')">
                    {{ $Resources.ExportToCsvButton }}
                </a>
            </li>
            <li>
                <a href="javascript:void(0)" role="button" @click="emit('exportToNewList')">
                    {{ $Resources.ExportToNewListButton }}
                </a>
            </li>
            <li>
                <a href="javascript:void(0)" role="button" @click="emit('exportToExistingList')">
                    {{ $Resources.ExportToExistingListButton }}
                </a>
            </li>
            <li>
                <a href="javascript:void(0)" role="button" @click="emit('sendExcelByMail')">
                    {{ $Resources.ExportSendExcelUrlToMailButton }}
                </a>
            </li>
        </template>
    </BSDropdownButton>
</template>
